import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";

import pusherJs from "pusher-js";
import { toast } from "react-toastify";
import ConditionalRender from "../../components/Common/ConditionalRender";
import Input from "../../components/Common/Input";
import { useHandleClickLoading } from "../../components/Common/utils";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import ShorcutPage from "../Hompages/ShorcutPage";

function CheckInvoice() {
    const apiKeyPusher = process.env.REACT_APP_PUSHER_KEY;
    const clusterPusher = process.env.REACT_APP_PUSHER_CLUSTER;
    const clusterName = process.env.REACT_APP_PUSHER_NAME;
    const isWebSetting = localStorage.getItem("isWebSetting");
    const parseWebSetting = JSON.parse(isWebSetting);
    const [PesananRealtimeData, setPesananRealtimeData] = useState([]);

    const [PesananRealtimeLoading, setPesananRealtimeLoading] = useState(true);
    const [invoice, setInvoice] = useState("");

    const dispatch = useDispatch();
    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {
        dispatch(isIdTarget(undefined));
        fetchPesananRealtime();

    }, [dispatch]);

    useEffect(() => {
        const pusher = new pusherJs(apiKeyPusher, {
            cluster: clusterPusher,
        });
        const channel = pusher.subscribe(clusterName);
        const handleNewMessage = (data) => {
            if (data.statusCode === 200) {
                if (data.Code === "actionLatestOrder") {
                    setPesananRealtimeData(data.data);
                }
            }
        };
        channel.bind("latest_order", handleNewMessage);
        return () => {
            channel.unbind("latest_order", handleNewMessage);
            pusher.disconnect();
        };
    }, [apiKeyPusher, PesananRealtimeData]);

    const fetchPesananRealtime = async () => {
        setPesananRealtimeLoading(true);
        try {

            const response = await ApiService({
                baseurl: "user/pesananTerakhir",
                method: "GET",
                XGORDON: "PESANANTERAKHIR",
            });
            setPesananRealtimeLoading(false);
            if (response?.statusCode === 200) {
                setPesananRealtimeData(response.result.data);
            } else {
                setPesananRealtimeData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    return (
        <div className="flex flex-col gap-3 flex-1 relative ">
<ShorcutPage/>

            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">

                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-[#22BDE2] text-2xl font-bold"> Cek transaksi kamu dengan
                        nomor Invoice</span>
                    <span className=" text-base font-light ">
                        Jika kamu telah memesan namun pesanan tidak terdaftar, tunggu 1 detik. Namun jika tak kunjung muncul silahkan cek lewat form dibawah  </span>
                    <span className=" text-base mt-3 mb-2">
                        Cari Nomor Transaksi
                    </span>
                    <div className="flex flex-row items-center gap-2">
                        <div className="flex flex-1">
                            <Input
                                id={1}
                                value={invoice}
                                onChange={(value) => {
                                    const inputValue = value;
                                    setInvoice(inputValue);
                                }}
                                type={"text"}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`Ketikan Nomor Transaksi Anda`}
                            />
                        </div>
                        <Button
                            iconLeft={<SearchIcon className="h-5 w-5" />}
                            type="fill"
                            color={'#ffffff'}
                            className={"bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"}
                            onClick={() => {
                                if (invoice.length < 4) {
                                    toast.error("Nomor Pesanan Kosong", {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });
                                } else {
                                    handleClickLoading(`/invoice/` + invoice);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/pngwing 1.png')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 h-full " />
                </div>
            </div>
            <div className="flex flex-col lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark p-3 relative">
                <span className="font-bold text-lg  line-clamp-1 ">Live Transaksi
                </span>
                <span className=" text-base italic  line-clamp-1 ">
                    Menampilkan 10 Transaksi dari semua jenis pembelian produk
                </span>
            </div>
            <div className="flex flex-col lg:rounded-lg rounded-none  shadow-inner bg-cardLight dark:bg-cardDark overflow-hidden relative">

                <div className=" pb-3 min-h-[585px]  relative">
                    <div className="overflow-x-scroll no-scrollbar  absolute z-10 top-0 left-0 right-0 bottom-0 lg:rounded-lg rounded-none">
                        <ConditionalRender
                            productsData={PesananRealtimeData}
                            isLoading={PesananRealtimeLoading}
                            model={"emptyData"}
                        >
                            <table className="min-w-full text-left text-sm font-light table-auto ">
                                <thead className="border-b  font-medium bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor">
                                    <tr>
                                        <th scope="col" className=" p-3">#</th>
                                        <th scope="col" className=" p-3">INVOICE</th>
                                        <th scope="col" className=" p-3">LAYANAN</th>
                                        <th scope="col" className=" p-3">TANGGAL</th>
                                        <th scope="col" className=" p-3">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {PesananRealtimeData.map((item, index) => (
                                        <tr key={index}
                                            className={`border-b border-[#ffffff2d] ${index % 2 === 0 ? 'bg-[#DFF9FF] dark:bg-[#ffffff13]' : ''
                                                }`}>
                                            <td className="whitespace-nowrap  p-3 font-medium text-center">{index + 1}</td>
                                            <td className="whitespace-nowrap  p-3"> {item.invoice}</td>
                                            <td className="whitespace-nowrap flex flex-col p-1">
                                                <span>{item.kategori}</span>
                                                <span className="font-medium text-base">{item.layanan}</span>
                                            </td>
                                            <td className="whitespace-nowrap  p-3">{item.datetime}</td>
                                            <td className="whitespace-nowrap flex-col p-2">
                                                <div className="flex flex-row">
                                                    <div className={`${item.status === "cancel"
                                                        ? "bg-[#F42536]"
                                                        : item.status === "refund"
                                                            ? "bg-[#ED610A]"
                                                            : item.status === "pending"
                                                                ? "bg-[#ED610A]"
                                                                : item.status === "paid"
                                                                    ? "bg-[#ED610A]"
                                                                    : item.status === "not_paid"
                                                                        ? "bg-[#000000]"
                                                                        : item.status === "processing"
                                                                            ? "bg-[#3694ff]"
                                                                            : item.status === "success"
                                                                                ? "bg-[#0ABE5D]"
                                                                                : null
                                                        } rounded-tr-lg rounded-bl-lg `}>
                                                        <span className=" text-xs font-medium line-clamp-1 m-2 my-1 text-darkColor">
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </ConditionalRender>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default CheckInvoice;
